import { FC, useState } from "react";
import { Image } from "antd";

type Props = {
  src?: string | null;
  alt?: string;
  className?: string;
  preview?: boolean;
  lazy?: boolean;
};

const ImageWithEmptyFallback: FC<Props> = ({ src, alt, className, preview = false, lazy = false }) => {
  const [failedSrc, setFailedSrc] = useState<string>();

  if (!src || failedSrc === src) {
    return (
      <div className={`flex items-center justify-center bg-background-minimal ${className ?? ""}`}>
        <svg className="h-1/3 w-1/3 text-icon-minimal" fill="none" viewBox="0 0 24 24" stroke="currentcolor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
      </div>
    );
  }

  return (
    <Image
      src={src}
      alt={alt}
      preview={preview}
      className={className}
      loading={lazy ? "lazy" : undefined}
      decoding={lazy ? "async" : undefined}
      onError={() => setFailedSrc(src)}
    />
  );
};

export default ImageWithEmptyFallback;
